export default "__VITE_ASSET__DirqM6rv__"